// import * as React from 'react';
import React, { useContext, useEffect, useState } from "react";
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import FadeLoader from "react-spinners/FadeLoader";
import { css } from "@emotion/react";
import TableSortLabel from '@mui/material/TableSortLabel';
import Paper from '@mui/material/Paper';
import { visuallyHidden } from '@mui/utils';
import { Button } from "react-bootstrap";
// reactstrap components
import { Row, Col, } from "reactstrap";
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Stack from '@mui/material/Stack';
import Autocomplete from '@mui/material/Autocomplete';
import AxiosContext from '../store/axios-context';
import AuthContext from '../store/auth-context';
import { useHistory } from 'react-router';
import ReactExport from "react-export-excel";
import Dropdown from "./Fields/Dropdown";
import InputDate from "./Fields/InputDate";
import InputField from "./Fields/InputField";
import moment from 'moment';
import { CSVLink } from "react-csv";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;
function createData(id, jobType, project, party, status, action) {
  return {
    id,
    jobType,
    project,
    party,
    status,
    action,
  };
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: 'id',
    numeric: false,
    disablePadding: true,
    label: 'Pending Invoices',
  },
 
  {
    id: 'date',
    numeric: false,
    disablePadding: false,
    label: 'Date',
  },
  {
    id: 'amount',
    numeric: false,
    disablePadding: false,
    label: 'Invoice Value',
  },
  {
    id: 'received-amount',
    numeric: false,
    disablePadding: false,
    label: 'Record Received Value',
  },
  
  {
    id: '',
    numeric: false,
    disablePadding: false,
    label: '',
  },
];

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>

        {headCells.map((headCell) => (
          <TableCell className="font-weight-bold"
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>

  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
  const { numSelected } = props;

  return (
    <span></span>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function InvoiceReceived() {
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [filters, setFilters] = useState(0);
  const [invoices, setInvoices] = useState([]);
  const [download_invoices, setDownloadInvoices] = useState([]);
  const [formError, setFormError] = useState(null);
  const [totalInvoices, setTotalInvoices] = useState(0);
  const axiosCtx = useContext(AxiosContext);
  const authCtx = useContext(AuthContext);
  const history = useHistory();

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [filterJobnumber, setFilterJobnumber] = useState('');

  const [totalPendingAmount, setTotalPendingAmount] = useState(0);

  const startDateChangeHandler = (event) => {
    setStartDate(event.target.value);
  };

  const endDateChangeHandler = (event) => {
    setEndDate(event.target.value);
  };

  const getInvoices = () => {
    setFilters(0);
    setLoading(true);
    const params = {
      page: page + 1,
      perPage: rowsPerPage
    };
    axiosCtx.instance.get(`invoice-received`,{ params })
      .then((response) => {
        console.log('response',response);
        setLoading(false);
        setInvoices(response.data.data);
        setDownloadInvoices(response.data.data);
        setTotalInvoices(response.data.totalInvoices);
      })
      .catch((error) => {
        // setFormError(error.response.data);
        setLoading(false);
      });
  };

  const getStatues = () => {
    axiosCtx.instance.get(`status`)
      .then((response) => {
        console.log('status',response.data.data)
        setStatuses(response.data.data);
      })
      .catch((error) => {
        // setFormError(error.response.data);
        // setLoading(false);
      });
  };
  const getJobs = () => {
 
    axiosCtx.instance.get(`job`)
      .then((response) => {
       console.log('job',response.data.data)
        setJob(response.data.data);
      })
      .catch((error) => {
        // setFormError(error.response.data);
      
      });
  };

  const getJobtypes = () => {
    axiosCtx.instance.get(`job-type`)
      .then((response) => {
        setJobtypes(response.data.data);
      })
      .catch((error) => {
      });
  };

  const getParties = () => {
    axiosCtx.instance.get(`party`)
      .then((response) => {
        setParties(response.data.data);
      })
      .catch((error) => {
      });
  };

  const getProjects = () => {
    axiosCtx.instance.get(`project`)
      .then((response) => {
        setProjects(response.data.data);
      })
      .catch((error) => {
      });
  };

  const statusChangeHandler = (event, value) => {
    if (value) {
      setStatus(value.id);
    } else {
      setStatus('');

    }
  };

  const projectChangeHandler = (event, value) => {
    if (value) {
      setProject(value.id);
    } else {
      setProject('');

    }
  };

  const subtypeChangeHandler = (event, value) => {
    if (value) {
      setSubtype(value.id);
    } else {
      setSubtype('');
    }

  };

  const getSubtypes = () => {
    axiosCtx.instance.get(`sub-type`)
      .then((response) => {

        setSubtypes(response.data.data);
      })
      .catch((error) => {
        // setFormError(error.response.data);
        // setLoading(false);
      });
  };

  const jobtypeChangeHandler = (event, value) => {
    if (value) {
      setJobtype(value.id);
    }
    else {
      setJobtype('');
    }
  };

  const partyChangeHandler = (event, value) => {
    // setParty(value.id);
    if (value) {
      setParty(value.id);
    }
    else {
      setParty('');
    }
  };

  const filterSubmit = (event) => {
    // event.preventDefault();
     if (!party) return;
    setFormError(null);
   setLoading(true);
  const formData = new FormData();
  formData.append("party_id", (party) ? party.id : '');
  axiosCtx.instance.post(`invoice-received/filter`, formData)
    .then((response) => {
      setInvoices(response.data.data);
      setDownloadInvoices(response.data.data);
      setTotalInvoices(response.data.totalInvoices);
      setLoading(false);
    })
    .catch((error) => {
      setLoading(false);
    });
  };

  const [projects, setProjects] = useState([]);
  const [jobtypes, setJobtypes] = useState([]);
  const [jobs, setJob] = useState([]);
  const [parties, setParties] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [subtypes, setSubtypes] = useState([]);

  const [status, setStatus] = useState('');
  const [project, setProject] = useState('');
  const [jobtype, setJobtype] = useState('');
  const [subtype, setSubtype] = useState('');
  const [party, setParty] = useState('');

  useEffect(() => {
    if (authCtx.isLoggedIn == false) {
      history.replace('/auth/Login');
    }
   
    getParties();
    getProjects();
  }, []);

  useEffect(() => {
  const total = invoices.reduce((sum, inv) => {
    const pending = Number(inv.amount) - Number(inv.received_amount || 0);
    return sum + (pending > 0 ? pending : 0);
  }, 0);

  setTotalPendingAmount(total.toFixed(2));
}, [invoices]);
  const onEditClickHandler = (item) => {
    console.log(item);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = invoices.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    event.stopPropagation();

    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  // const [startDate, setStartDate] = useState(new Date());
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showFilter, setShowFilter] = useState(false);

  const [paymentReceivedDate, setPaymentReceivedDate] = useState('');

  const filterClose = () => {
    setShowFilter(false);
  }

  const handleSavePayments = () => {
  if (!paymentReceivedDate) {
    alert("Please select payment received date");
    return;
  }

  const updatedInvoices = invoices.filter(inv => inv.received_amount && Number(inv.received_amount) > 0);

  const payload = updatedInvoices.map(inv => ({
    id: inv.id,
    received_amount: inv.received_amount,
    payment_received_date: paymentReceivedDate,
    status: 'Paid'
  }));

  setLoading(true);
  axiosCtx.instance.post('invoice-received/mark-paid', { invoices: payload })
    .then(() => {
      alert('Invoices updated successfully.');
      setInvoices([]); // Clear list
    })
    .catch((error) => {
      console.error(error);
      alert("Something went wrong!");
    })
    .finally(() => {
      setLoading(false);
    });
};

  const filterClear = () => {
    setFilters(0);
    setParty(null);
  setInvoices([]);
 
  }

  const isSelected = (name) => selected.indexOf(name) !== -1;
  const [age, setAge] = React.useState('');
  const handleChange = (event) => { setAge(event.target.value); };
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - invoices.length) : 0;

  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  let [excelData, setExcelData] = useState([]);
  const sortInvoice = () => {
    let data = Array.isArray(download_invoices) ? [...download_invoices] : [];

    data = data.map(row => ({
      ...row,
      job_type: row.job_type ? row.job_type.type : "",
      project: row.project ? row.project.name : "",
      party: row.party ? row.party.name : "",
      invoice_date: row.invoice_date ? moment(row.invoice_date).format("YYYY-MM-DD") : '',
      currency: row.currency ? row.currency.currency_label : "",
      amount: row.amount ? parseFloat(row.amount).toFixed(2) : "0.00",
      received_amount: row.received_amount ? parseFloat(row.received_amount).toFixed(2) : "0.00",
    }));
  
    setExcelData(data);
  };

  const headers = [
    { label: "Pending Invoices", key: "invoice_number" },
    { label: "Date", key: 'invoice_date' },
    { label: "Currency", key: 'currency' },
    { label: "Amount", key: 'amount' },
    { label: "Received Amount", key: 'received_amount' },
  ];
  let [loading, setLoading] = useState(false);
  let [color, setColor] = useState("#2f67c9");
  return (
    <div className="content">
       {loading && loading == true ?
        <div className="custom-loader">
          <FadeLoader color={color} loading={loading} css={override} size={150} />
        </div>
        : ''
      }
      <div className="d-flex justify-content-between align-items-center border-bottom mb-4">
       
      <div className="d-flex align-items-center mb-3">
  <div className="mr-4" style={{ minWidth: 300 }}>
    <Dropdown
      id="parties"
      placeholder="Parties"
      label="name"
      options={parties}
      value={party}
      onChange={(event, newValue) => {
        setParty(newValue);
      }}
    />
  </div>
  <div style={{ minWidth: 300 }}>
    <InputDate
      id="payment_received_date"
      placeholder="Payment Received Date"
      label="Payment Received Date"
      value={paymentReceivedDate}
      onChange={(e) => setPaymentReceivedDate(e.target.value)}
    />
  </div>
  <Button
                    className="my-0  "
                    variant="primary"
                    onClick={filterSubmit}
                  >
                    Apply
                  </Button>
                   <Button
                    className="my-0 mr-3"
                    variant="secondary"
                    onClick={filterClear}
                  >
                    Clear
                  </Button>
</div>

        
      </div>

      <Box sx={{ width: '100%' }}>
        <Paper sx={{ width: '100%', mb: 2 }}>
          <EnhancedTableToolbar numSelected={selected.length} />
          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size={dense ? 'small' : 'medium'}
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={invoices.length}
              />
              <TableBody>
                {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 rows.slice().sort(getComparator(order, orderBy)) */}
               {stableSort(invoices, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    const isItemSelected = isSelected(row.id);
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                      <TableRow
                        hover
                        onClick={(event) => handleClick(event, row.id)}
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.id}
                        selected={isItemSelected}
                      >
                       <TableCell>{row.invoice_number}</TableCell>
<TableCell>{moment(row.invoice_date).format("YYYY-MM-DD")}</TableCell>
<TableCell>{row.currency.currency_label} {Number(row.amount).toFixed(2)}</TableCell>
<TableCell>
  <input
    type="number"
    className="form-control"
    value={row.received_amount || ''}
    onChange={(e) => {
      const value = e.target.value;
      setInvoices((prev) =>
        prev.map((inv) =>
          inv.id === row.id ? { ...inv, received_amount: value } : inv
        )
      );
    }}
  />
</TableCell>

                      </TableRow>
                    );
                  })}
                {/* {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: (dense ? 33 : 53) * emptyRows,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )} */}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={invoices.length}  
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />

          <div className="d-flex justify-content-between align-items-center p-3 border-top">
  <h5>Total Pending Amount: <strong>₹{totalPendingAmount}</strong></h5>
 <h5>Total Received Amount: <strong>₹{
  invoices
    .filter(inv => inv.received_amount !== '' && inv.received_amount !== null && !isNaN(inv.received_amount))
    .reduce((sum, inv) => sum + parseFloat(inv.received_amount), 0)
    .toFixed(2)
}</strong></h5>
  <Button
    variant="primary"
    onClick={handleSavePayments}
    disabled={loading || !invoices.length}
  >
    {loading ? 'Saving...' : 'Save Payments'}
  </Button>
</div>

<div className="text-center mt-3">
  <small className="text-muted">On save, all invoice statuses will be changed to <strong>Paid</strong>.</small>
</div>

        </Paper>

      </Box>
    </div>
  );
}
  